import { Form } from "antd";
import { useUpdateSellerContact } from "hooks/seller";
import { t } from "i18next";
import { useState } from "react";
import { notify } from "utils/helperFuncs";

const useModalUpdateAddress = ({ sellerID, refetch, contact }) => {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const { handleUpdateContact } = useUpdateSellerContact();

  let initialValues = {
    ...contact,
    cityID: contact?.ward?.version === "V1" ? null : contact?.cityID,
    wardID: contact?.ward?.version === "V1" ? null : contact?.wardID,
  };

  const handleValuesChange = async (changedValues, allValues) => {
    const values = await form.getFieldsValue();
    if (changedValues?.cityID) {
      form.setFieldsValue({
        ...values,
        wardID: null,
      });
    }
  };

  const handleOpen = () => {
    form.setFieldsValue({
      ...contact,
      cityID: contact?.ward?.version === "V1" ? null : contact?.cityID,
      wardID: contact?.ward?.version === "V1" ? null : contact?.wardID,
    });
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  async function updateContact() {
    try {
      const values = await form.validateFields();
      await handleUpdateContact({
        id: contact?.id,
        contact: {
          ...values,
          email: values?.email || null,
          tel2: values?.tel2 || null,
          sellerID: sellerID,
        },
      })
        .then(() => {
          notify.success({
            message: t("seller.componentAddressList.messageUpdateAddressSuccess"),
          });
          setVisible(false);
          form.resetFields();
          refetch();
        })
        .catch(() => {
          notify.error({
            message: t("seller.componentAddressList.messageUpdateAddressError"),
          });
          setVisible(true);
        });
    } catch (err) {
      console.info(err);
    }
  }

  return { updateContact, initialValues, visible, handleCancel, form, handleOpen, handleValuesChange };
};

export default useModalUpdateAddress;
